/* ===========================================================================
   Keep the headline price above the bundle selector in step with the tier the
   shopper has actually chosen.

   Before this, the top of the page always showed the single-unit variant price
   and its compare-at ($47.99 / $71.99 / SAVE 33%) while the selected tier —
   Buy 1 Get 2 Free by default — was really $47.99 against $143.97. Two different
   "was" prices on one screen.

   The tier rows already contain the money strings Liquid rendered
   (`{{ base_price | money }}`, `{{ t2_compare | money }}`, ...), so this mirrors
   those strings rather than re-implementing currency formatting — no assumptions
   about symbol, separator or placement, and it follows the shop's money format
   automatically.

   Tier 1 ("Buy 1", standard price) carries no compare-at of its own, so it
   restores whatever the page was originally rendered with.
   =========================================================================== */
(function () {
  'use strict';

  var widget, container, curEl, wasEl, badgeEl;
  var original = null;   // the Liquid-rendered tier-1 state, captured once
  var applying = false;  // guard so our own writes don't re-trigger the observer
  var observer = null;   // the price-block MutationObserver (paused while we write)
  /* Write helpers that touch the DOM only when something actually changes — a same-value
     textContent write still creates mutation records, which is what looped this script
     ~110×/s before 2026-09-12. */
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function setDisplay(el, v) { if (el && el.style.display !== v) el.style.display = v; }
  function endApply() {
    /* MutationObserver callbacks are delivered as microtasks after this call stack; the flag
       must outlive them, so it is cleared from a task, not synchronously. */
    window.setTimeout(function () { applying = false; }, 0);
  }

  /* "$1,439.70" -> 1439.7 ; tolerant of symbol placement and thousands marks. */
  function toNumber(s) {
    if (!s) return NaN;
    var cleaned = String(s).replace(/[^0-9.,]/g, '');
    // last separator followed by exactly 2 digits is the decimal point
    var m = cleaned.match(/^(.*)([.,])(\d{2})$/);
    if (m) return parseFloat(m[1].replace(/[.,]/g, '') + '.' + m[3]);
    return parseFloat(cleaned.replace(/[.,]/g, ''));
  }

  function activeTier() {
    var tiers = widget.querySelectorAll('.b1g2__tier');
    for (var i = 0; i < tiers.length; i++) {
      var r = tiers[i].querySelector('.b1g2__radio');
      if (r && r.checked) return tiers[i];
    }
    return null;
  }

  function textOf(el) { return el ? el.textContent.trim() : ''; }

  function sync() {
    var tier = activeTier();
    if (!tier || !curEl) return;

    var price = textOf(tier.querySelector('.b1g2__price'));
    var compare = textOf(tier.querySelector('.b1g2__compare'));
    if (!price) return;

    applying = true;

    setText(curEl, price);

    /* No compare on this tier (the plain "Buy 1" row) — put the page back to the
       variant's own compare-at and savings, which is what it means. */
    if (!compare) {
      setText(wasEl, original.was); setDisplay(wasEl, original.was ? '' : 'none');
      setText(badgeEl, original.badge); setDisplay(badgeEl, original.badge ? '' : 'none');
      endApply();
      return;
    }

    setText(wasEl, compare); setDisplay(wasEl, '');

    if (badgeEl) {
      var p = toNumber(price), c = toNumber(compare);
      if (isFinite(p) && isFinite(c) && c > p && c > 0) {
        setText(badgeEl, 'SAVE ' + Math.round((c - p) / c * 100) + '%'); setDisplay(badgeEl, '');
      } else {
        /* Can't compute a sensible number — hide rather than show a wrong one. */
        setDisplay(badgeEl, 'none');
      }
    }

    endApply();
  }

  function init() {
    widget = document.querySelector('b1g2-offer');
    container = document.querySelector('.custom-price-container');
    if (!widget || !container) return;

    curEl = container.querySelector('.custom-current-price');
    wasEl = container.querySelector('.custom-was-price');
    badgeEl = container.querySelector('.custom-save-badge');
    if (!curEl) return;

    /* Captured before the first sync, so the "Buy 1" tier can restore exactly
       what Liquid rendered. A product with no compare-at price renders neither
       the was-price nor the badge; those stay null and are simply skipped. */
    original = {
      current: textOf(curEl),
      was: textOf(wasEl),
      badge: textOf(badgeEl)
    };

    var radios = widget.querySelectorAll('.b1g2__radio');
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', sync);
    }
    /* The tier can also be switched by clicking the row rather than the input. */
    widget.addEventListener('click', function () { window.setTimeout(sync, 0); });

    /* product-info.js re-renders the price block on variant change, which would
       otherwise restore the single-unit price under a bundle tier. */
    var host = container.parentElement || container;
    observer = new MutationObserver(function (records) {
      if (applying) return;
      /* Only react to changes that did not originate from the price elements we write to. */
      var foreign = false;
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target, n = t.nodeType === 3 ? t.parentNode : t;
        if (n !== curEl && n !== wasEl && n !== badgeEl) { foreign = true; break; }
      }
      if (!foreign) return;
      var fresh = document.querySelector('.custom-price-container');
      if (fresh && fresh !== container) {
        container = fresh;
        curEl = container.querySelector('.custom-current-price');
        wasEl = container.querySelector('.custom-was-price');
        badgeEl = container.querySelector('.custom-save-badge');
      }
      window.setTimeout(sync, 0);
    }).observe(host, { childList: true, subtree: true, characterData: true });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
